import { CrudForm } from '../shared/CrudPage';
import { stockAdjustmentService } from '@kss/api';
import type { StockAdjustment, StockAdjustmentCreate, StockAdjustmentFilter } from '@kss/api';
import { loadWarehouseOptions } from '../shared/formLoaders';

type F = {
  warehouseId: string; adjustmentNumber: string; adjustmentDate: string;
  reason: string; notes: string;
};
const today = new Date().toISOString().slice(0, 10);
const empty: F = { warehouseId: '', adjustmentNumber: '', adjustmentDate: today, reason: '', notes: '' };

/**
 * Adjustment header form. Line-item editing (`items[]`) lives in a
 * follow-up screen — this page only captures the batch metadata.
 */
export default function NewStockAdjustment() {
  return (
    <CrudForm<StockAdjustment, StockAdjustmentCreate, StockAdjustmentFilter, F>
      title="stock adjustment" service={stockAdjustmentService} idKey="stockAdjustmentId"
      basePath="/panel/stock-adjustments" emptyForm={empty}
      fields={[
        { key: 'adjustmentNumber', label: 'Adjustment #', required: true, placeholder: 'ADJ-2026-0001' },
        { key: 'adjustmentDate', label: 'Date', type: 'date', required: true },
        { key: 'warehouseId', label: 'Warehouse', type: 'search', loadOptions: loadWarehouseOptions, required: true, placeholder: 'Pick a warehouse' },
        { key: 'reason', label: 'Reason', placeholder: 'Damaged in handling' },
        { key: 'notes', label: 'Notes', type: 'textarea', fullWidth: true },
      ]}
      fromEntity={(r) => ({
        warehouseId: r.warehouseId ?? '',
        adjustmentNumber: r.adjustmentNumber ?? '',
        adjustmentDate: r.adjustmentDate?.slice(0, 10) ?? today,
        reason: r.reason ?? '', notes: r.notes ?? '',
      })}
      toEntity={(f, id) => ({
        stockAdjustmentId: id, warehouseId: f.warehouseId,
        adjustmentNumber: f.adjustmentNumber || undefined,
        adjustmentDate: f.adjustmentDate || undefined,
        reason: f.reason || undefined, notes: f.notes || undefined,
      })}
      validate={(f) => !f.warehouseId.trim() ? 'Warehouse is required' : !f.adjustmentNumber.trim() ? 'Adjustment number is required' : null}
    />
  );
}
